<template>
    <div class="flex flex-col items-center justify-center h-screen px-4">
      <img 
        src="@/assets/gratitutude.png" 
        alt="Gratitude Illustration"
        class="w-1/2 mb-8"
      />
      <h1 class="text-5xl text-custom-yellow mb-4">
        <i class="fas fa-thumbs-up text-custom-yellow mr-2"></i> Thank You!
      </h1>
      <div class="mb-8 text-center text-gray-600 italic">
        
        <p>Your willingness to donate blood is truly appreciated.</p> 
        <p>Together, we are making a difference in the lives of many.</p>
        <i class="fas fa-heart text-custom-yellow ml-2 text-5xl"></i>
      </div>

      
      <!-- <router-link :to="{ name: 'Home' }" class="px-4 py-2 border rounded text-white bg-custom-yellow">
        Return Home
      </router-link> -->
    </div>
  </template>
  
  <script>
  export default {
    name: "GratitudeMessage",
  };
  </script>
  
  <style scoped>
  /* Add any additional styles if necessary */
  </style>
  